import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3PraceZiemne from "../../components/offer/3praceZiemne";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Prace ziemne w ogrodzie i kształtowanie krajobrazu | Gdańsk, Gdynia, Kaszuby</title>
        <meta name="title" content="Prace ziemne w ogrodzie i kształtowanie krajobrazu | Gdańsk, Gdynia, Kaszuby" />
        <meta
          name="description"
          content="Roboty ziemne w ogrodzie: wymiana gruntu, drenaże, kształtowanie skarp i podbudowy pod nawierzchnie. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Prace ziemne w ogrodzie i kształtowanie krajobrazu | Gdańsk, Gdynia, Kaszuby"
        />
        <meta
          property="og:description"
          content="Roboty ziemne w ogrodzie: wymiana gruntu, drenaże, kształtowanie skarp i podbudowy pod nawierzchnie. Działamy w Gdańsku, Gdyni, Wejherowie, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3PraceZiemne />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
